// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Allison/Allison-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Baskervville/Baskervville-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Baskervville/Baskervville-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Roboto_Slab/RobotoSlab-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Allison';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: 'Baskervville';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
  font-family: 'RobotoSlab';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

.certificate {
  width: 297mm;
  /* A4 Landscape */
  height: 180mm;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  font-family: "Baskervville", serif;
  background: white;
  direction: ltr;
}

.cert-row {
  display: flex;
  height: 100%;
}





.logo-circle {
  background: white;
  border-radius: 50%;
  padding: 3mm;
  top: 110px;
  left: 120px;
  position: absolute;


  z-index: 1;
}


.cert-right {
  flex: 0 0 65%;
  text-align: center;
  padding: 100px 20mm 50px 0mm;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cert-title {
  font-size: 50pt;
  letter-spacing: 2px;
  font-family: 'RobotoSlab';
}

.cert-subtitle {
  font-size: 14pt;
  margin-bottom: 10mm;
  font-family: 'RobotoSlab', serif;
  text-align: center;
  color: #1a1a40;
  /* رنگ متن */
  position: relative;
  display: inline-block;
}

.cert-subtitle::before,
.cert-subtitle::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 100px;
  /* طول خط‌ها */
  height: 1px;
  /* ضخامت خط‌ها */
  background-color: #888;
  /* رنگ خط */
}

.cert-subtitle::before {
  right: 65%;

}

.cert-subtitle::after {
  left: 65%;

}

.cert-name {
  font-family: "Allison" !important;
  font-size: 40pt;
  border-bottom: 1px solid #888;
  padding-bottom: 5px;
}

.cert-text {
  font-size: 12pt;
  margin: 3mm 0 8mm 0;
}

.cert-footer {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
}

.cert-footer .label {
  font-weight: bold;
  font-size: 10pt;
}

.signature img {
  width: 40mm;
}

.signature {
  z-index: 1;
}

.cert-left {
  flex: 0 0 35%;
  /* حدود یک‌سوم صفحه */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* اضافه‌ها رو مخفی کن */
}

.green-img {
  height: 70vh;
  width: 70vw;
  z-index: 1;
  margin-top: -50px;
  transform: rotate(265deg);
  /* از وسط بچرخونه */
}

.badge {
  /* Star 1 */

  position: absolute;
  width: 232px;
  height: 232px;
  left: 1438px;
  top: 728px;

  background: #2BA769;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.25);
  border-radius: 19.4814px;

}



.badge::after {
  content: "";
  width: 140px;
  height: 140px;
  background: #a5e2c4;
  /* رنگ وسط */
  border-radius: 50%;
}

.ff {
  font-family: "RobotoSlab";
}

.p-relative {
  position: relative;
}

.txt-r {
  position: absolute;
  width: 270px;
  left: -60px;
  top: 40px;
  z-index: 0;
}


.logo-cert {
  position: absolute;
  top: 30px;
  left: 30px;
}

.addr {
  font-family: "RobotoSlab";
  color: #2BA769;
  margin-right: 70px;

}


@media (max-width:1100px) {
  .green-img {
    height: 100vh;
    width: 300vw;
  }
}

.certificate {
  width: 297mm;
  height: 180mm;
  overflow: hidden;
  position: relative;
  background-color: white;
}

.green-container {
  position: absolute;
  top: 0;
  
  height: 100%;
}

.green-img {
  height: 100%;
  width: auto;
  min-width: 30mm;     /* مقدار ثابت برای حاشیه تزئینی */
}


.qr-code{
  z-index: 20;
}`, "",{"version":3,"sources":["webpack://./src/styles/certificate.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B;8DAC2F;AAC7F;;AAEA;EACE,yBAAyB;EACzB,+DAAoF;AACtF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;;;;;AAMA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;;;EAGlB,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,SAAS;;AAEX;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,UAAU;;EAEV,mBAAmB;EACnB,2CAA2C;EAC3C,wBAAwB;;AAE1B;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;;AAEpB;;;AAGA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;;EAEN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe,MAAM,iCAAiC;AACxD;;;AAGA;EACE,WAAW;AACb","sourcesContent":["@font-face {\n  font-family: 'Allison';\n  src: url('../fonts/Allison/Allison-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Baskervville';\n  src: url('../fonts/Baskervville/Baskervville-VariableFont_wght.ttf') format('truetype'),\n    url('../fonts/Baskervville/Baskervville-Italic-VariableFont_wght.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'RobotoSlab';\n  src: url('../fonts/Roboto_Slab/RobotoSlab-VariableFont_wght.ttf') format('truetype');\n}\n\n.certificate {\n  width: 297mm;\n  /* A4 Landscape */\n  height: 180mm;\n  box-sizing: border-box;\n  overflow: auto;\n  position: relative;\n  font-family: \"Baskervville\", serif;\n  background: white;\n  direction: ltr;\n}\n\n.cert-row {\n  display: flex;\n  height: 100%;\n}\n\n\n\n\n\n.logo-circle {\n  background: white;\n  border-radius: 50%;\n  padding: 3mm;\n  top: 110px;\n  left: 120px;\n  position: absolute;\n\n\n  z-index: 1;\n}\n\n\n.cert-right {\n  flex: 0 0 65%;\n  text-align: center;\n  padding: 100px 20mm 50px 0mm;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.cert-title {\n  font-size: 50pt;\n  letter-spacing: 2px;\n  font-family: 'RobotoSlab';\n}\n\n.cert-subtitle {\n  font-size: 14pt;\n  margin-bottom: 10mm;\n  font-family: 'RobotoSlab', serif;\n  text-align: center;\n  color: #1a1a40;\n  /* رنگ متن */\n  position: relative;\n  display: inline-block;\n}\n\n.cert-subtitle::before,\n.cert-subtitle::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 100px;\n  /* طول خط‌ها */\n  height: 1px;\n  /* ضخامت خط‌ها */\n  background-color: #888;\n  /* رنگ خط */\n}\n\n.cert-subtitle::before {\n  right: 65%;\n\n}\n\n.cert-subtitle::after {\n  left: 65%;\n\n}\n\n.cert-name {\n  font-family: \"Allison\" !important;\n  font-size: 40pt;\n  border-bottom: 1px solid #888;\n  padding-bottom: 5px;\n}\n\n.cert-text {\n  font-size: 12pt;\n  margin: 3mm 0 8mm 0;\n}\n\n.cert-footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: auto;\n}\n\n.cert-footer .label {\n  font-weight: bold;\n  font-size: 10pt;\n}\n\n.signature img {\n  width: 40mm;\n}\n\n.signature {\n  z-index: 1;\n}\n\n.cert-left {\n  flex: 0 0 35%;\n  /* حدود یک‌سوم صفحه */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  /* اضافه‌ها رو مخفی کن */\n}\n\n.green-img {\n  height: 70vh;\n  width: 70vw;\n  z-index: 1;\n  margin-top: -50px;\n  transform: rotate(265deg);\n  /* از وسط بچرخونه */\n}\n\n.badge {\n  /* Star 1 */\n\n  position: absolute;\n  width: 232px;\n  height: 232px;\n  left: 1438px;\n  top: 728px;\n\n  background: #2BA769;\n  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.25);\n  border-radius: 19.4814px;\n\n}\n\n\n\n.badge::after {\n  content: \"\";\n  width: 140px;\n  height: 140px;\n  background: #a5e2c4;\n  /* رنگ وسط */\n  border-radius: 50%;\n}\n\n.ff {\n  font-family: \"RobotoSlab\";\n}\n\n.p-relative {\n  position: relative;\n}\n\n.txt-r {\n  position: absolute;\n  width: 270px;\n  left: -60px;\n  top: 40px;\n  z-index: 0;\n}\n\n\n.logo-cert {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n}\n\n.addr {\n  font-family: \"RobotoSlab\";\n  color: #2BA769;\n  margin-right: 70px;\n\n}\n\n\n@media (max-width:1100px) {\n  .green-img {\n    height: 100vh;\n    width: 300vw;\n  }\n}\n\n.certificate {\n  width: 297mm;\n  height: 180mm;\n  overflow: hidden;\n  position: relative;\n  background-color: white;\n}\n\n.green-container {\n  position: absolute;\n  top: 0;\n  \n  height: 100%;\n}\n\n.green-img {\n  height: 100%;\n  width: auto;\n  min-width: 30mm;     /* مقدار ثابت برای حاشیه تزئینی */\n}\n\n\n.qr-code{\n  z-index: 20;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
